import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { api } from 'lib/httpClient';

async function fetchDashboard({ queryKey }) {
  const [, params] = queryKey;

  const { data } = await api.get(`dashboard/open-tranche/${params.trancheId}`);

  return data.data;
}

function useOpenTrancheDashboard({ params }) {
  return useQuery({
    queryKey: ['openTrancheDashboard', params],
    queryFn: fetchDashboard,
    enabled: !!params?.trancheId,
    placeholderData: keepPreviousData,
    staleTime: 4 * 60 * 60 * 1000,
  });
}

export default useOpenTrancheDashboard;
